module.exports = __webpack_public_path__ + "static/media/csv.a922e6ba.svg";